/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropdownOptionParam
 */
export interface DropdownOptionParam {
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionParam
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionParam
     */
    value: string;
}

/**
 * Check if a given object implements the DropdownOptionParam interface.
 */
export function instanceOfDropdownOptionParam(value: object): value is DropdownOptionParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function DropdownOptionParamFromJSON(json: any): DropdownOptionParam {
    return DropdownOptionParamFromJSONTyped(json, false);
}

export function DropdownOptionParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropdownOptionParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function DropdownOptionParamToJSON(json: any): DropdownOptionParam {
    return DropdownOptionParamToJSONTyped(json, false);
}

export function DropdownOptionParamToJSONTyped(value?: DropdownOptionParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'value': value['value'],
    };
}

